import invariant from "invariant";
import { DataModel } from "../../base/DataModel.js";
import { ListDataModel } from "../../base/ListDataModel.js";
import { containerMaxPort, type ContainerPortData } from "./types.js";

export class ContainerPort extends DataModel<ContainerPortData> {
  public readonly internal: number;
  public readonly external: number;
  public readonly protocol?: string;

  public constructor(data: ContainerPortData) {
    super(data);
    const [portString, protocol] = data.split("/");
    invariant(portString, "Invalid container port definition!");
    const [internal, external] = portString.split(":");
    invariant(internal, "Invalid container port definition!");
    this.internal = parseInt(internal);
    this.external = external ? parseInt(external) : parseInt(internal);
    this.protocol = protocol;
  }

  public toString(externalOnly?: boolean): string {
    return externalOnly || this.internal === this.external
      ? `${this.external}${this.protocol ? `/${this.protocol}` : ""}`
      : `${this.internal}:${this.external}${this.protocol ? `/${this.protocol}` : ""}`;
  }

  public static validatePort(port: string): boolean {
    const portObj = new ContainerPort(port);
    return (
      portObj.internal > 0 &&
      portObj.internal <= containerMaxPort &&
      portObj.external > 0 &&
      portObj.external <= containerMaxPort
    );
  }
}

export class ContainerPortList extends ListDataModel<ContainerPort> {
  public constructor(ports: ContainerPortData[]) {
    super(
      ports.map((p) => new ContainerPort(p)),
      ports.length,
    );
  }

  public toStringArray(): string[] {
    return this.items.map((p) => p.toString());
  }
}
